jQuery(function($) {
  //console.log('test');
function loadMore(paged) {
    $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
         action: 'wf_load_more',
         paged: currentPage,
        },
        success: function (res) {
           // console.log(paged);
           // console.log(res.max);
            if(paged >= res.max) {
              $('#load-more').hide();
            }
            $('.publication-list').append(res.html);
          }
        });
}

let currentPage = 1;
$('#load-more').on('click', function(e) {
    e.preventDefault();
    currentPage++; // Do currentPage + 1, because we want to load the next page
    loadMore(currentPage);
   // console.log(currentPage);



});

});